import { derived, writable } from 'svelte/store';
import type { Writable } from 'svelte/store';
import { wStorage } from '@centerhealth/common/storage';
import { getDeviceInfo, MeterTypes } from '@centerhealth/common/devices';
import type {
  SubscriptionBillingCycle,
  SubscriptionPlanType,
} from '@centerhealth/common/subscriptions';
import type { ICheckoutInfo } from '../interfaces';

export const selectedPlan: Writable<SubscriptionPlanType> = writable('50');

export const selectedBillingCycle: Writable<SubscriptionBillingCycle> = writable('monthly');

// meter store with local storage persistence
export const meterStore: Writable<MeterTypes> = writable('lightning');

// get MeterTag (Duo,Nano,Duo C) from meterType (lightning,v1,usb)
export const displayedMeter = derived(meterStore, (meter) => getDeviceInfo(meter)!.meterTag);

// state for checking if device was auto selected
export const deviceAutoSelected: Writable<true | false> = writable(false);

// state for checking if app is initialized
// app initialised is dormant and not effective due to switching away from client router navigation
// we can remove after testing hypothesis for conversion rate
export const appInitialized: Writable<true | false> = writable(false);

// State for checkout info
export const checkoutStore: Writable<ICheckoutInfo> = wStorage('checkoutStore');

// Store whether pixel is initialised
export const pixelInitialised: Writable<boolean> = writable(false);

export const queryParameters: Writable<string> = writable('');

export const emojiVariant: Writable<string> = writable('');

// AB Test for CTA full width variation
export const mobileCtaFullWidthVariation: Writable<'control' | 'withFullWidth'> = writable();
